import { LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TextNode } from "lexical";

import { TypographyTextNode } from "./TypographyTextNode";

export const EDITOR_THEME = {
  text: {
    bold: "bold",
    italic: "italic",
    underline: "underlined",
    strikethrough: "strikethrough",
  },
  list: {
    ul: "list unordered",
    ol: "list ordered",
    listitem: "listitem",
  },
};

export const EDITOR_NODES = [
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  LinkNode,
  TypographyTextNode,
  {
    replace: TextNode,
    with: (node: TextNode) => {
      const next = new TypographyTextNode(node.getTextContent());
      next.setFormat(node.getFormat());
      next.setDetail(node.getDetail());
      next.setMode(node.getMode());
      next.setStyle(node.getStyle());
      return next;
    },
    withKlass: TypographyTextNode,
  },
];
